module.exports = __webpack_public_path__ + "img/elec.458da3f0.png";